import SettlementAPI from "../api/settlement";
import Vue from 'vue'

export const settlements = {
    state: {
        settlements: [],
        settlementOptions:{
            lineCount:0,
            orderBy:'surname',
            orderDirection:'asc',
            itemsPerPage:20,
            selectedYear:0,
            selectedMonth:0,
            selectedStatus:null,
            selectedCourse:null,
            selectedChild:null,
            itemAdded:false,
            itemSearched:false
        },
        settlementsLoadStatus: 0,
        settlementsAppendStatus: 0,
        settlementAddStatus: 0,
        settlementAddText: "",

        settlementEdit: {
                selectedYear:0,
                selectedMonth:0,
                range:'all',
                children:[],
                courses:[],
                selectedCourses:[],
                log:[]
            
        },
        settlementEditDefault: {
            
                selectedYear:0,
                selectedMonth:0,
                range:'all',
                children:[],
                courses:[],
                selectedCourses:[],
                log:[]
            
        },

        settlementEditLoadStatus: 0,
        settlementEditStatus: 0,
        settlementEditText: "",
        settlementDeleteStatus: 0,
        settlementDeleteText: "",
    },

    actions: {
        loadSettlements({ state, commit, dispatch }) {
            commit("setSettlementsLoadStatus", 1);
                SettlementAPI.getSettlements({
                    offset:0,
                    itemsPerPage:state.settlementOptions.itemsPerPage, 
                    orderBy:state.settlementOptions.orderBy,
                    orderDirection:state.settlementOptions.orderDirection,
                    selectedYear:state.settlementOptions.selectedYear,
                    selectedMonth:state.settlementOptions.selectedMonth,
                    selectedStatus:state.settlementOptions.selectedStatus,
                    selectedCourse:state.settlementOptions.selectedCourse,
                    selectedChild:state.settlementOptions.selectedChild,
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setSettlementLineCount", response.data.lineCount);
                    commit("setSettlements", response.data.settlements);
                    dispatch("applyIndexOnSettlements");
                    commit("setSettlementsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setSettlements", []);
                    commit("setSettlementsLoadStatus", 3);
                });
         
        },

        loadMoreSettlements({ state, commit, dispatch }) {
            commit("setSettlementsLoadStatus", 1);
                SettlementAPI.getSettlements({
                    offset:state.settlements.length,
                    itemsPerPage:state.settlementOptions.itemsPerPage, 
                    orderBy:state.settlementOptions.orderBy,
                    orderDirection:state.settlementOptions.orderDirection,
                    selectedYear:state.settlementOptions.selectedYear,
                    selectedMonth:state.settlementOptions.selectedMonth,
                    selectedStatus:state.settlementOptions.selectedStatus,
                    selectedCourse:state.settlementOptions.selectedCourse,
                    selectedChild:state.settlementOptions.selectedChild,
                })
                .then(function(response) {
                    commit("setSettlementLineCount", response.data.lineCount);
                    commit("setSettlements", _.concat(state.settlements, response.data.settlements));
                    //commit("setSettlements", response.data);
                    dispatch("applyIndexOnSettlements");
                    commit("setSettlementsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setSettlements", []);
                    commit("setSettlementsLoadStatus", 3);
                });
         
        },

        searchSettlements({ state, commit, dispatch },data) {
            commit("setSettlementsLoadStatus", 1);
                SettlementAPI.searchSettlements({
                    selectedYear:state.settlementOptions.selectedYear,
                    selectedMonth:state.settlementOptions.selectedMonth,
                    selectedStatus:state.settlementOptions.selectedStatus,
                    selectedCourse:state.settlementOptions.selectedCourse,
                    selectedChild:state.settlementOptions.selectedChild,
                    filterableHeaders:data.filterableHeaders,
                    q:data.q
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setSettlementSearchedTrue");
                    commit("setSettlementLineCount", response.data.lineCount);
                    commit("setSettlements", response.data.settlements);
                    dispatch("applyIndexOnSettlements");
                    commit("setSettlementsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setSettlements", []);
                    commit("setSettlementsLoadStatus", 3);
                });
         
        },

        loadSettlementsInCourse({ state, commit, dispatch },data) {
            commit("setSettlementEditLoadStatus", 1);
                SettlementAPI.getSettlementsInCourse({
                    selectedYear:data.selectedYear,
                    selectedMonth:data.selectedMonth,
                })
                .then(function(response) {
                    commit("setSettlementEdit", response.data);
                    commit("setSettlementEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setSettlementEdit", []);
                    commit("setSettlementEditLoadStatus", 3);
                });
         
        },

        loadUnpayedSettlements({ state, commit, dispatch },data) {
            commit("setSettlementsLoadStatus", 1);
                SettlementAPI.getUnpayedSettlements({
                    selectedYear:state.settlementOptions.selectedYear,
                    selectedMonth:state.settlementOptions.selectedMonth,
                })
                .then(function(response) {
                    commit("setSettlements",response.data);
                    dispatch("applyIndexOnSettlements");
                    commit("setSettlementsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setSettlementEdit", []);
                    commit("setSettlementsLoadStatus", 3);
                });
         
        },

        loadSettlementLog({ state, commit, dispatch },data) {
            commit("setSettlementLog", []);
            commit("setSettlementEditLoadStatus", 1);
                SettlementAPI.getSettlementLog(data.slug)
                .then(function(response) {
                    commit("setSettlementLog", response.data.log);
                    commit("setSettlementEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setSettlementLog", []);
                    commit("setSettlementEditLoadStatus", 3);
                });
         
        },
        loadSettlementRecalculate({ state, commit, dispatch },data) {
            commit("setSettlementEditLoadStatus", 1);
                SettlementAPI.getSettlementRecalculate(data.slug)
                .then(function(response) {
                    commit("setSettlementLog", response.data.log);
                    dispatch("loadSettlements");
                    commit("setSettlementEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setSettlementLog", []);
                    commit("setSettlementEditLoadStatus", 3);
                });
         
        },
        generateSettlements({ state, commit, dispatch },data) {
            commit("setSettlementAddStatus", 1);
                SettlementAPI.getGenerateSettlements({
                    selectedYear:data.year,
                    selectedMonth:data.month,
                    range:data.range,
                    ids:data.ids
                })
                .then(function(response) {
                    commit("setSettlementAddText", response.data);
                    commit("setSettlementAddStatus", 2);
                    dispatch("loadSettlements");
                })
                .catch(function() {
                    commit("setSettlementEdit", []);
                    commit("setSettlementAddStatus", 3);
                });
         
        },

        generateSettlementsBO({ state, commit, dispatch },data) {
            commit("setSettlementAddStatus", 1);
                SettlementAPI.getGenerateSettlementsBO({
                    selectedYear:state.settlementOptions.selectedYear,
                    selectedMonth:state.settlementOptions.selectedMonth,
                    child_id:data.child_id,
                    amount:data.amount,
                    hour:data.hour,
                    meal:data.meal
                })
                .then(function(response) {
                    commit("setSettlementAddText", response.data);
                    commit("setSettlementAddStatus", 2);
                    dispatch("loadSettlements");
                })
                .catch(function() {
                    commit("setSettlementEdit", []);
                    commit("setSettlementAddStatus", 3);
                });
         
        },

        sendSettlementsNotificaiton({ state, commit, dispatch },data) {
            commit("setSettlementEditStatus", 1);
                SettlementAPI.getSettlementNotificationSend(data.slug)
                .then(function(response) {
                    commit("setSettlementEditText", response.data);
                    commit("setSettlementEditStatus", 2);
                    dispatch("loadSettlements");
                })
                .catch(function() {
                    commit("setSettlementEdit", []);
                    commit("setSettlementEditStatus", 3);
                });
         
        },

        setSettlementOptions({ state, commit, dispatch },data){
            commit("setSettlementOptions",data.options);
            //if(data.options.selectedMonth>0){
                dispatch("loadSettlements");
            //}
        },

        setUnpayedSettlementOptions({ state, commit, dispatch },data){
            commit("setSettlementOptions",data.options);
            dispatch("loadUnpayedSettlements");
        },
        loadSettlementEditDefault({ commit }) {
            commit("setSettlementEditDefault");
        },
        applyIndexOnSettlements({ commit, state, dispatch, rootState }) {
            let localSettlements = state.settlements;

            var i = 1;
            localSettlements.forEach(settlement => {
                if(Vue._.isNumber(settlement.month)){
                    settlement.month = Vue._.find(rootState.lookups.months, { 'value': settlement.month }).text;
                }
                if(_.isArray(settlement.courses_with_history)){
                    settlement.courses = _.map(settlement.courses_with_history,u=>'<span>' + u.name + '</span>').join(', ')
                }
                if(_.isArray(settlement.rates_with_history)){
                    settlement.rates = _.map(settlement.rates_with_history,u=>'<span>' + u.name + '</span>').join(', ')
                }
                if(Vue._.isArray(settlement.settlements)){
                    if(settlement.settlements.length>0 && Vue._.isNumber(settlement.settlements[0].status)){
                        settlement.settlements[0].status = Vue._.find(rootState.lookups.settlementsStatus, { 'value': settlement.settlements[0].status }).text;
                     }
                    settlement.settlements = settlement.settlements[0];
                    
                }

                // if(Vue._.isNumber(settlement.settlements.status)){
                //     settlement.settlements.status = 'aaa';//= Vue._.find(rootState.lookups.settlementsStatus, { 'value': settlement.settlements.status }).text;
                // }

                settlement.lp = i;
                i++;
            });

            commit("setSettlements",localSettlements);
        },
        
        forceDeleteSettlement({ commit, state, dispatch }, data) {
            commit("setSettlementDeleteStatus", 1);

            SettlementAPI.forceDeleteSettlement(data.slug)
                .then(function(response) {
                    commit("setSettlementDeleteStatus", 2);
                    commit("setDeletedSettlement",response.data)
                    dispatch("applyIndexOnSettlements");
                })
                .catch(function() {
                    commit("setSettlementDeleteStatus", 3);
                });
        },

    },
    mutations: {
        setSettlementOptions(state,options){
            state.settlementOptions = options;
        },
        setSettlementsLoadStatus(state, status) {
            state.settlementsLoadStatus = status;
        },
        setSettlementsAppendStatus(state, status) {
            state.settlementsAppendStatus = status;
        },
        setSettlements(state, settlements) {
            state.settlements = settlements;
        },
        setSettlementAddStatus(state, status) {
            state.settlementAddStatus = status;
        },
        setSettlementAddText(state, text) {
            state.settlementAddText = text;
        },
        setSettlementLineCount(state, lineCount) {
            state.settlementOptions.lineCount = lineCount;
        },
        setOptionsItemAddedAndSearchedFalse(state) {
            state.settlementOptions.itemAdded = false;
            state.settlementOptions.itemSearched = false;
        },
        setSettlementSearchedTrue(state) {
            state.settlementOptions.itemSearched = true;
        },
        setSettlementEdit(state, settlement) {
            state.settlementEdit.courses = settlement;
        },
        setSettlementLog(state, log) {
            state.settlementEdit.log = log;
        },
        
        setDeletedSettlement(state, settlement) {
            var index = Vue._.findIndex(state.settlements,{'id':settlement.child_id});
            state.settlements[index].settlements = [];
            //state.settlements.splice(index,1);
        },
        // setEditedSettlement(state, settlement) {
        //     var lp = _.find(state.settlements,{'id':settlement.child_id}).lp;
        //     var index = Vue._.findIndex(state.settlements,{'id':settlement.child_id});
           
        //     state.settlements[index] = settlement;
        //     state.settlements[index].lp = lp;
        // },

        setSettlementEditDefault(state) {
            state.settlementAddStatus = 0;
            state.settlementAddText = "";
            state.settlementEdit = { ...state.settlementEditDefault };
        },
        setSettlementEditStatus(state, status) {
            state.settlementEditStatus = status;
        },
        setSettlementEditText(state, text) {
            state.settlementEditText = text;
        },
        setSettlementEditLoadStatus(state, status) {
            state.settlementEditLoadStatus = status;
        },
        setSettlementDeleteStatus(state, status) {
            state.settlementDeleteStatus = status;
        },
        setSettlementDeletedText(state, text) {
            state.settlementDeleteText = text;
        }
    },

    getters: {
        getSettlementOptions(state){
            return state.settlementOptions;
        },
        getSettlementsLoadStatus(state) {
            return state.settlementsLoadStatus;
        },
        getSettlementsAppendStatus(state) {
            return function(){
                return state.settlementsAppendStatus;
            }
        },
        getSettlements(state) {
            return state.settlements;
        },
        getSettlementAddStatus(state) {
            return function(){
                return state.settlementAddStatus;
            } 
        },
        getSettlementAddText(state) {
            return state.settlementAddText;
        },
        getSettlementEdit(state) {
            return state.settlementEdit;
        },
        getSettlementLog(state) {
            return state.settlementEdit.log;
        },
        getSettlementEditStatus(state) {
          return function(){
            return state.settlementEditStatus;
          }
        },
        getSettlementEditText(state) {
            return state.settlementEditText;
        },
        getSettlementEditLoadStatus(state) {
            return state.settlementEditLoadStatus;
            
        },
        getSettlementDeleteStatus(state) {
            return function(){
                return state.settlementDeleteStatus;
            }
        },
        getSettlementDeleteText(state) {
            return state.settlementDeleteText;
        }
    }
};
